/** @jsxImportSource @emotion/react */
import { useTranslation } from 'react-i18next';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import { useAppTheme } from '@hooks/useAppTheme';
import { styles } from './styles';
import { DotsElasticLoading } from '@components/ui/DotsElasticLoading';

interface Props {
  isSaving: boolean | undefined;
  onClick: () => void;
  hasChanges: boolean;
  online: boolean;
}

export const AutoSaveBtn = ({ isSaving, onClick, hasChanges, online }: Props) => {
  const { t } = useTranslation();
  const theme = useAppTheme({});

  return isSaving !== undefined ? (
    <div css={styles.container(theme, !!isSaving, online, hasChanges)} onClick={() => hasChanges  ? onClick() : null}>
      <span css={styles.textContainer}>{!online ? t('general.offline') : isSaving ? t('auto-save.saving-state') : hasChanges ? t('auto-save.pending-changes') : t('auto-save.saved-state')}</span>

     {(!hasChanges || isSaving) && online ? (
        <span css={styles.iconContainer}>{isSaving ? <DotsElasticLoading /> : <CheckCircleOutlineIcon css={styles.checkIcon} />}</span>
      ) : null }
    </div>
  ) : (
    <div css={styles.emptyContainer} />
  );
};

export default AutoSaveBtn;
